import React, { useContext } from 'react'

import { ReactComponent as FailureImage } from '@assets/images/500_artwork.svg'
import { Button } from '@components/Button'

import { BackToDashboardButton } from '../../Components/BackToDashboardButton'
import { AstuteContext } from '../../context'

export const ConsentFailed = () => {
  const {
    state: {
      paths: { retryPath },
    },
  } = useContext(AstuteContext)

  return (
    <div className='astute-request-wrapper'>
      <h1>Something went wrong</h1>
      <p className='astute-request-wrapper--subheading'>
        Your client did not provide digital consent. We were unable to retrieve their Astute report.
      </p>
      <div className='astute-request-wrapper--graphic-svg' style={{marginBlockEnd: '2rem'}}>
        <FailureImage style={{width: '350px'}}/>
      </div>
      <div className='astute-back-to-dashboard'>
        <BackToDashboardButton />
        <div className='refresh-button-wrapper'>
          <Button href={retryPath} name='Retry request'>
            Retry request
          </Button>
        </div>
      </div>
    </div>
  )
}
